import PoweredBy from './PoweredBy';
import { Spinner } from '@contentful/f36-components'

const Loading = () => {
  return (
    <div>
      <div style={{margin: 'auto', width: '20px', padding: '50px 0'}}>
        <Spinner variant="default" />
      </div>
      <PoweredBy/>
    </div>
  );
}

export default Loading